export default {
  state: {
	  cashierCart:localStorage.getItem('cashier-cart') ?  JSON.parse(localStorage.getItem('cashier-cart')) : [],
	  cashierCartIndex: localStorage.getItem('cashier-cart-index') ? localStorage.getItem('cashier-cart-index') : -1,
  },
  mutations: { 
	  setCashierCart(state,param){
		  state.cashierCart = param;
		  localStorage.setItem('cashier-cart',JSON.stringify(param));
	  },
	  setCashierCartIndex(state,param){
		  state.cashierCartIndex=param;
		  localStorage.setItem('cashier-cart-index',param);
	  }
  }
}